import { render } from "./DemographicReport.vue?vue&type=template&id=3a458547&scoped=true"
import script from "./DemographicReport.vue?vue&type=script&lang=js"
export * from "./DemographicReport.vue?vue&type=script&lang=js"

import "./DemographicReport.vue?vue&type=style&index=0&id=3a458547&lang=scss&scoped=true"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a458547"]])

export default __exports__